import React, { FC, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import OrLabel from './OrLabel'

export interface OAuthButtonProps {
  idpName: string
  className: string
  loading: boolean
  includeOrLabel: boolean
  onClick: () => void
}

const OAuthButton: FC<OAuthButtonProps> = ({
  idpName,
  className,
  loading,
  includeOrLabel,
  onClick,
}) => {
  if (!idpName) {
    return null
  }

  return (
    <Fragment>
      <div className={className}>
        <Button
          isLoading={loading}
          disabled={loading}
          id="oauth-submit"
          testId="oauth-submit"
          size="regular"
          type="button"
          variation="primary"
          onClick={onClick}
          block
          inline={false}
        >
          <FormattedMessage id="loginProviderLabel" />
          <span className="ml2">{idpName}</span>
        </Button>
      </div>
      {/* // TODO: this error popped up when moving the checkout-instore project
      // to checkout-instore-legacy, but needs to be fixed at some point
      // @ts-ignore */}
      {includeOrLabel && <OrLabel className="mt3" />}
    </Fragment>
  )
}

export default OAuthButton
